import _ from "lodash";
import React, { useState } from "react";
import I18nHOC from "UIComponents/I18nHOC";
import UILabel from "UIComponents/UILabel";
import SelectDropdown from "UIComponents/SelectDropdown";
import UnitSelection from "AppComponents/UnitSelection";
import classes from "./UnitFromGradeSelection.scss";
import { compose } from "lib/apolloClient";
import { colors, fontStyle } from "Constants";
import { connect } from "react-redux";
import {
  showUnitSelection,
  getFilteredCoursesBasedOnViewOrManagePermission,
} from "ClassRoom/modules/utils";
import { getAssessmentDataFromLocalStorage } from "Assessments/modules/AssessmentModule";
import { getSubjectsWithNoGradebook } from "GradingSetup/modules/Utils";
import { ASSIGNMENTS_MANAGE_PERMISSION_IN_CALENDAR } from "Constants/permissionConstants";

const styles = {
  notesTextStyle: {
    fontSize: "1.2rem",
    color: colors.neutral400,
    ...fontStyle.regular,
  },
  classTextStyle: {
    ...fontStyle.demiBold,
  },
  unitLabelText: {
    color: colors.blue400,
    fontSize: "1.6rem",
    ...fontStyle.bold,
  },
  unitsCountText: {
    color: colors.blue400,
    fontSize: "1.6rem",
    ...fontStyle.regular,
  },
};

const UnitFromGradeSelection = ({
  courseList,
  selectedItems,
  onCourseSelect,
  unitSelectionStepStyles,
  updateSelectedItems,
  selectedCourse,
  t,
  pageName,
  curriculumProgramType,
  creationMode,
  setDialogBoxParams,
  getAssessmentDataFromLocalStorage,
  testId,
}) => {
  const [selectedCourseId, setSelectedCourseId] = useState(selectedCourse);
  const [searchText, updateSearchText] = useState("");

  const showUnitSelectionComponent = showUnitSelection({ creationMode });

  const onClassSelect = async ({ selectedCourseId }) => {
    const selectedCourse = _.find(
      courseList,
      course => course.courseId === selectedCourseId
    );
    onCourseSelect({ course: selectedCourse });
    setSelectedCourseId(selectedCourseId);

    if (showUnitSelectionComponent) {
      const {
        assessmentId,
        currentStep,
        assessmentData,
      } = await getAssessmentDataFromLocalStorage({
        creationMode,
        courseId: selectedCourseId,
      });

      if (assessmentId) {
        setDialogBoxParams({
          key: creationMode,
          creationMode,
          assessmentId,
          currentStep,
          assessmentData,
        });
      }
    }
  };
  const handleUnitSearch = value => {
    updateSearchText(value);
  };

  const isFromCalendar = _.includes(["DAILY_VIEW", "WEEKLY_VIEW"], pageName);

  let filteredCourseList = courseList;

  // in case of DP, filter classes with subjects with only quick as we can't create
  // Learning experiences or assessments in them
  if (isFromCalendar && curriculumProgramType === "IB_DP") {
    filteredCourseList = _.filter(filteredCourseList, course => {
      const subjectType = _.get(course, "subjects.0.type");
      return !_.includes(getSubjectsWithNoGradebook(), subjectType);
    });
  }
  filteredCourseList = getFilteredCoursesBasedOnViewOrManagePermission({
    courses: filteredCourseList,
    permissionsToCheck: [ASSIGNMENTS_MANAGE_PERMISSION_IN_CALENDAR],
  });

  return (
    <div className={classes.mainContainer}>
      <UILabel
        label={`${t("calendar:choose_class")}`}
        labelStyle={styles.classTextStyle}
      ></UILabel>
      <div className={classes.courseDropDownContainer}>
        <SelectDropdown
          name={"selectedCourseId"}
          value={selectedCourseId}
          placeholder={t("calendar:search_for_a_class")}
          updateInputField={onClassSelect}
          options={_.map(filteredCourseList, course => ({
            label: course.label,
            value: course.courseId,
          }))}
          isCheckList={false}
          showAllOption={false}
          parentContainerStyle={{
            width: "664px",
          }}
          testId={`${testId}-courseDropdownSelection`}
        />
        {showUnitSelectionComponent ? (
          <UILabel
            label={`${t("calendar:note_units_that_belong")}`}
            labelStyle={styles.notesTextStyle}
          ></UILabel>
        ) : null}
      </div>
      {selectedCourseId && showUnitSelectionComponent ? (
        <UnitSelection
          updateSelectedItems={updateSelectedItems}
          styles={unitSelectionStepStyles}
          cardDimensions={{ width: 320, height: 280 }}
          selectedItems={selectedItems}
          courseId={selectedCourseId}
          showEmptyState={true}
          isSearchEnabled={true}
          searchText={searchText}
          selectedCourseId={selectedCourseId}
          handleUnitSearch={handleUnitSearch}
        />
      ) : null}
    </div>
  );
};

const mapActionCreators = {
  getAssessmentDataFromLocalStorage,
};

const mapStateToProps = (state, ownProps) => {
  const { type: curriculumProgramType } =
    _.get(state, "platform.currentCurriculumProgram", {}) || {};

  return {
    curriculumProgramType,
  };
};

export default compose(
  I18nHOC({ resource: ["common", "calendar"] }),
  connect(mapStateToProps, mapActionCreators)
)(UnitFromGradeSelection);
